import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { CASES, CASE_THUMBS, optimize } from "../data/casesData";

// Full-screen loading overlay shown until the real content assets (all case
// thumbnails) have actually downloaded — not just the initial HTML. Keeps a
// minimum on-screen time so it never just flickers, then fades out crisply.
export default function GlobalLoader() {
  const [assetsReady, setAssetsReady] = useState(false);
  const [minElapsed, setMinElapsed] = useState(false);
  const [gone, setGone] = useState(false);

  const loaded = assetsReady && minElapsed;

  // Minimum visible duration to avoid a flash.
  useEffect(() => {
    const t = setTimeout(() => setMinElapsed(true), 800);
    return () => clearTimeout(t);
  }, []);

  // Preload every case thumbnail; only finish once all have resolved.
  useEffect(() => {
    const urls = CASES.map((c) => optimize(CASE_THUMBS[c.id], 640)).filter(Boolean);
    if (!urls.length) { setAssetsReady(true); return; }
    let done = 0;
    let cancelled = false;
    const tick = () => {
      done += 1;
      if (done >= urls.length && !cancelled) setAssetsReady(true);
    };
    urls.forEach((u) => {
      const img = new Image();
      img.onload = tick;
      img.onerror = tick;
      img.src = u;
    });
    const cap = setTimeout(() => !cancelled && setAssetsReady(true), 15000); // safety cap
    return () => { cancelled = true; clearTimeout(cap); };
  }, []);

  useEffect(() => {
    if (!loaded) return;
    const t = setTimeout(() => setGone(true), 500);
    return () => clearTimeout(t);
  }, [loaded]);

  if (gone) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-[#0F0C16] transition-opacity duration-500 ${loaded ? "opacity-0" : "opacity-100"}`}
      style={{ pointerEvents: loaded ? "none" : "auto" }}
      data-testid="global-loader"
    >
      <Loader2 className="h-12 w-12 animate-spin text-[#8A90A0]" strokeWidth={2.5} />
    </div>
  );
}
